import axios from 'axios'
import { getToken } from '@/api/coreclient'
import { gzip } from 'pako'

const apiUrl = import.meta.env.VITE_API_URL

export default {
  async fillExcel(
    body: unknown,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string
  ) {
    const token = await getToken()

    let url = '/templater/excel'

    if (useDevFile) {
      url += '?useDevFile=true'
    }

    const compressed = gzip(JSON.stringify(body))

    return axios.post(apiUrl + url, compressed, {
      responseType: 'blob',
      params: {
        hiddenTabs,
        deletedTabs
      },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Content-Encoding': 'gzip'
      }
    })
  }
}
